import { render } from "./PriorityIcon.vue?vue&type=template&id=31eace56"
import script from "./PriorityIcon.vue?vue&type=script&lang=js"
export * from "./PriorityIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__